import React from "react";
import { useMutation } from "react-query";
import { useTranslation } from "react-i18next";
import {
  Box,
  Button,
  Divider,
} from "@mui/material";

import { useRedirectIfUnauthenticated } from "utils/azureAD/useRedirectIfUnauthenticated";
import { getSynchronizationItemsAsync } from "PdfDocumentGrid/pdfDocuments.service";
import { resetDatabase, updateSettings } from "utils/DexieDBManager";
import { RESOURCES_KEYS } from "utils/i18n/resources";
import ErrorBoundary from "utils/ErrorBoundary/ErrorBoundary";
import { isPwa } from "utils/pwa";

import { SortableCategoriesUsingDragAndDrop } from "./sortableCategoriesUsingDragAndDrop";
import useOnlineStatus from "utils/InternetChecker/useOnlineStatus";

const Settings: React.FunctionComponent = () => {
  const { accounts } = useRedirectIfUnauthenticated();
  const { t: translate } = useTranslation();
  const { isOnline} = useOnlineStatus()
  const username = accounts[0]?.username;

  const {
    mutate: getSynchronizationItems,
    isLoading: isMutateGetSynchronizationItemsLoading,
  } = useMutation(["synchronizationItems", { username }], () => getSynchronizationItemsAsync(username, { hasToSyncDocuments: true }));

  const handleLoadAllVersions = () => {
    updateSettings({ key: "versionsApiHasBeenCalled", value: false }).then(() =>
      getSynchronizationItems()
    );
  };

  const handleResetDatabase = () => {
    resetDatabase();
  };

  

  return (
    <Box display="flex" flexDirection="column">
      {isPwa && (
        <>
          <Box m={"2rem"} display="flex" justifyContent={"center"}>
            {/* <StorageQuota /> */}
            {/* <ToggleButtonGroup
          exclusive
          size="small"
          color="primary"
          value={language}
          onChange={handleLanguage}
          sx={{ marginBottom: "1rem", maxHeight: "50px" }}
          aria-label="language"
        >
          <ToggleButton value={LANGUAGES.fr_FR} aria-label="FR">
            <SvgIcon component={FlagFR} inheritViewBox fontSize="small" />
          </ToggleButton>
          <ToggleButton value={LANGUAGES.en_US} aria-label="EN">
            <SvgIcon component={FlagUK} inheritViewBox fontSize="small" />
          </ToggleButton>
        </ToggleButtonGroup> */}
            <Box display="flex" flexDirection="row" flexWrap={"wrap"}>
              <Button
                size="small"
                color="error"
                variant="outlined"
                sx={{ width: "20rem", height: "2rem", margin: "0.5rem" }}
                disabled={!isOnline}
                onClick={handleResetDatabase}
              >
                {translate(RESOURCES_KEYS.RESET_DATABASE)}
              </Button>
              <Button
                size="small"
                color="primary"
                variant="outlined"
                sx={{ width: "20rem", height: "2rem", margin: "0.5rem" }}
                disabled={!isOnline || isMutateGetSynchronizationItemsLoading}
                onClick={handleLoadAllVersions}
              >
                {translate(RESOURCES_KEYS.LOAD_ALL_VERSIONS_API_REQUEST)}
              </Button>
            </Box>
          </Box>
          <Divider />
        </>
      )}
     {isOnline && <SortableCategoriesUsingDragAndDrop/>}
    </Box>
  );
};

const SettingsPage = () => {
  const { t: translate } = useTranslation();
  return (
    <ErrorBoundary
      title={translate(RESOURCES_KEYS.ERROR_BOUNDARY_TITLE, {
        page: translate(RESOURCES_KEYS.MENU_SETTINGS),
      })}
    >
      <Settings />
    </ErrorBoundary>
  );
};

export default SettingsPage;
